// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Request from "../../core/Request.res.js";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as OrderEdit from "./OrderEdit.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as OrderRoutes from "./OrderRoutes.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as OrderEditForm from "../../modules/Order/OrderEditForm.res.js";
import * as OrderEditPage from "./OrderEditPage.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as OrderEdit__Config from "./OrderEdit__Config.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OrderEdit__Queries from "./OrderEdit__Queries.res.js";

function OrderEditContainer(props) {
  let id = props.id;
  let authState = Auth.useState();
  let navigate = Navigation.useNavigate();
  let notifier = Notifier.use(undefined, undefined);
  let match = React.useState(() => []);
  let setCartRowErrors = match[1];
  let match$1 = OrderEdit__Queries.OrderQuery.useLazy(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let executeQuery = match$1[0];
  React.useEffect(() => {
    if (Stdlib_Option.isSome(id)) {
      executeQuery(undefined, undefined, {
        id: Stdlib_Option.getOr(id, "")
      });
    }
  }, [id]);
  let dataResult = OrderEdit__Config.useQuery(id, match$1[1], authState, props.supplierId, props.shopId);
  let onSubmitSuccess = React.useCallback(submissionResponse => {
    if (submissionResponse !== undefined) {
      if (id !== undefined) {
        executeQuery(undefined, undefined, OrderEdit__Queries.OrderQuery.makeVariables(submissionResponse, undefined));
        return notifier.clear();
      } else {
        navigate({
          replace: true
        }, OrderRoutes.showRoute(submissionResponse));
        return notifier.clear();
      }
    } else {
      return notifier.add({
        TAG: "Error",
        _0: Request.serverErrorMessage
      }, undefined, undefined);
    }
  }, [id]);
  let onSubmitFailure = React.useCallback(message => notifier.reset({
    TAG: "Error",
    _0: message
  }, undefined, undefined), []);
  if (typeof dataResult !== "object") {
    if (dataResult === "Error") {
      return JsxRuntime.jsx(Placeholder.make, {
        status: "Error"
      });
    } else {
      return JsxRuntime.jsx(Placeholder.make, {
        status: "Loading"
      });
    }
  }
  let match$2 = dataResult._0;
  let statuses = match$2.statuses;
  return JsxRuntime.jsx(OrderEditForm.Core.LegacyProvider.make, {
    initialValues: match$2.initialValues,
    schema: [
      {
        TAG: "CustomString",
        _0: "SupplierId",
        _1: (value, param) => {
          if (value === "") {
            return {
              TAG: "Error",
              _0: I18n.t("Missing supplier")
            };
          } else {
            return {
              TAG: "Ok",
              _0: undefined
            };
          }
        }
      },
      {
        TAG: "Custom",
        _0: "Cart",
        _1: param => {
          let cart = param.cart;
          let cartErrors = Stdlib_Array.filterMap(cart.products, product => {
            let match;
            if (product.TAG === "Unit") {
              let match$1 = product._0;
              match = [
                match$1.id,
                match$1.quantity
              ];
            } else {
              let match$2 = product._0;
              match = [
                match$2.id,
                match$2.quantity.toNumber()
              ];
            }
            if (match[1] <= 0) {
              return {
                key: match[0],
                message: I18n.t("Ordered quantity must be greater than 0.")
              };
            }
          });
          let validated = OrderEdit.isBeforeReception(statuses) ? (setCartRowErrors(previousCartRowErrors => {
              if (previousCartRowErrors.length === 0 && cartErrors.length === 0) {
                return previousCartRowErrors;
              } else {
                return cartErrors;
              }
            }), cart.products.length !== 0 && cartErrors.length === 0) : cart.products.length !== 0;
          if (validated) {
            return {
              TAG: "Ok",
              _0: undefined
            };
          } else {
            return {
              TAG: "Error",
              _0: "The order should have at least one product in cart."
            };
          }
        }
      }
    ],
    children: JsxRuntime.jsx(OrderEditPage.make, {
      id: id,
      name: match$2.name,
      updatedAt: match$2.updatedAt,
      statuses: statuses,
      receptionFinishedAt: match$2.receptionFinishedAt,
      cartRowErrors: match[0],
      onRequestCartRowsError: errors => setCartRowErrors(previousCartRowErrors => {
        if (previousCartRowErrors.length === 0 && errors.length === 0) {
          return previousCartRowErrors;
        } else {
          return errors;
        }
      })
    }),
    id: id,
    onSubmitFailure: onSubmitFailure,
    onSubmitSuccess: onSubmitSuccess
  });
}

let make = React.memo(OrderEditContainer);

let Config;

let OrderQuery;

let OrderVariantsStockQuery;

export {
  Config,
  OrderQuery,
  OrderVariantsStockQuery,
  make,
}
/* make Not a pure module */
